import React from 'react';
import { motion } from 'framer-motion';
import Lottie from 'lottie-react';
import loadingJson from '../../assets/loading.json';

const PremiumLoading = ({ text }) => {
  return (
    <div className="elite-loader-overlay">
      <div className="loader-container">
        {/* Lottie Animation Wrapper */}
        <motion.div 
          className="lottie-wrapper"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <Lottie 
            animationData={loadingJson} 
            loop={true} 
            style={{ width: 280, height: 280 }}
          />
        </motion.div>

        {/* Loading Progress Wrapper */}
        <div className="progress-wrapper">
          <h2 className="brand-label-text">NewBiz MyGeo</h2>
          <p className="loading-label-text">{text || "Loading"}</p>
          <div className="loading-bar-bg">
            <motion.div 
              className="loading-bar-fill"
              animate={{ width: ["0%", "100%"] }}
              transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
            />
          </div>
        </div>
      </div>

      <style>{`
                .elite-loader-overlay {
                    position: fixed;
                    inset: 0;
                    background: #ffffff; /* Solid White background */
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 99999;
                    font-family: 'Montserrat', sans-serif;
                    overflow: hidden;
                }

                .loader-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 30px;
                }

                .lottie-wrapper {
                    position: relative;
                    width: 280px;
                    height: 280px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .progress-wrapper {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 12px;
                    width: 350px;
                }

                .brand-label-text {
                    font-size: 1.4rem;
                    font-weight: 700;
                    color: #064e3b; /* Premium brand green */
                    margin: 0;
                    letter-spacing: 1px;
                }

                .loading-label-text {
                    font-size: 1rem;
                    font-weight: 500;
                    color: #64748b; /* Slate grey color */
                    margin: 0;
                    letter-spacing: 0.5px;
                }

                .loading-bar-bg {
                    height: 8px;
                    width: 100%;
                    background: #f1f5f9; /* Light grey progress track */
                    border-radius: 10px;
                    position: relative;
                    overflow: hidden;
                }

                .loading-bar-fill {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    background: #064e3b; /* Deep green matching the mockup circle */
                    border-radius: 10px;
                }
            `}</style>
    </div>
  );
};

export default PremiumLoading;
